import { Component, OnInit, OnDestroy } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { Profile } from "src/app/Models/profile.interface";
import { Subject } from "rxjs";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-email-preference-checker",
  templateUrl: "./email-preference-checker.component.html",
  styleUrls: ["./email-preference-checker.component.css"],
  animations: [
    trigger("visible", [
      state("void", style({ opacity: 0, height: 0 })),
      state("show", style({ opacity: 1, height: 50 })),
      transition("void => *", [animate("500ms ease-in-out")]),
      transition("* => void", [animate("500ms ease-in-out")]),
    ]),
  ],
})
export class EmailPreferenceCheckerComponent implements OnInit, OnDestroy {
  leaving = new Subject();
  constructor(private um: UserManager, private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }
  profile: Profile;
  config;
  shouldDisplay: boolean = false;
  ngOnInit(): void {
    this.um
      .getProfileSubject()
      .pipe(takeUntil(this.leaving))
      .subscribe((profile) => {
        this.profile = profile;
        if (!profile) {
          return;
        }
        const touched =
          profile?.preferences?.notifications?.emailsEnabledTouched;
        const enabled = profile?.preferences?.notifications?.emailsEnabled;
        this.shouldDisplay = !touched && !enabled;
      });
  }

  turnOnNotifications() {
    this.um.turnOnEmailNotifications();
  }

  ngOnDestroy() {
    this.leaving.next();
    this.leaving.complete();
  }
}
